import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url,attendanceserver} from '@/utils/baseUrl';

//部门树
export async function getDeptTree(params) {
    return post(oaserver+'/organize/getDeptTree', params, true)
}
